// extracted by mini-css-extract-plugin
module.exports = {"vehicleMassLoad":"styles_vehicleMassLoad__1ewcp","vehiclesForSales":"styles_vehiclesForSales__3pFtM","vehicleMassLoadBackButtom":"styles_vehicleMassLoadBackButtom__1vRIV"};